import { Bell, Mail, MessageSquare } from 'lucide-react';


const channels = [
    {
        icon: <Bell size={20} />,
        label: 'In-app notifications',
        description: 'Application, inspection and payment updates appear in the bell menu.'
    },
    {
        icon: <Mail size={20} />,
        label: 'Email',
        description: 'Used for verification codes and password-reset codes sent to your registered email.'
    },
    {
        icon: <MessageSquare size={20} />,
        label: 'SMS',
        description: 'Verification codes are also sent to the phone number on your profile.'
    }
]

/**
 * ZCT stores no notification preferences: `NotificationController` exposes only list,
 * unread-count, mark-read and mark-all-read, and no column on the user or anywhere else
 * records a per-channel choice. The toggles this page used to show were local `useState`
 * that persisted nothing, so they are gone rather than pretending a setting was saved.
 */
export default function NotificationSettings() {
    return (
        <div className="w-full py-3 pr-3 space-y-6">
            <div>
                <h1 className="text-lg font-semibold">Notification Settings</h1>
                <p className="text-xs text-secondary-300">
                    How ZCT reaches you about your applications.
                </p>
            </div>

            <div className="p-4 text-sm text-secondary bg-primary-50 border border-primary-100 rounded-lg">
                Notification preferences cannot be changed yet. ZCT does not store per-channel
                settings, so every account receives the notifications below.
            </div>

            <div className="space-y-3">
                {
                    channels.map((channel) => (
                        <div
                            className="flex items-start gap-3 p-4 border border-gray-200 rounded-lg"
                            key={channel.label}
                        >
                            <span className="text-secondary-300 pt-0.5">{channel.icon}</span>

                            <div>
                                <p className="text-sm font-medium text-secondary">{channel.label}</p>
                                <p className="text-xs text-secondary-300">{channel.description}</p>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};
